import styled from "styled-components";

export const BoxFilters = styled.div`
    display: flex;
    flex-direction: column;
    gap: 10px;
    margin-top: 1rem;
`;

export const RowInput = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr 1fr;
  align-items: flex-start;
  gap: 10px;

  @media (max-width: 426px) {
    grid-template-columns: 1fr;

    button {
      width: 100%;
      max-width: 100%;
      padding: 0.4rem 0 !important;
      margin: 0;
    }
  }
`;

export const RowInputModal = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;
`;

export const BoxTitleGrid = styled.div`
  display: flex;
  flex-direction: row;
  gap: 10px;
  margin-top: 1rem;

  @media (max-width: 600px) {
    justify-content: space-between;
    align-items: center;
    flex-wrap: wrap;
  }
`;

export const TitleGrid = styled.h5`
  font-weight: bold;
  font-size: 0.95rem;
  margin-bottom: 0;
  display: flex;
  flex-direction: column;
  justify-content: center;
`;

export const InputLogin = styled.div`
&&& {
  div {
    margin: 0 !important;
  }
  margin: 0 !important;

  .makeStyles-inputTextCustom-60 {
    margin: 0 !important;
  }
  border-radius: 5px;
  
  & .MuiInputLabel-outlined.MuiInputLabel-shrink {
    transform: translate(12px, 7px) scale(0.75);
    padding-left: 0;
  }
  & label.Mui-focused {
      color: ${({ theme }) => theme.pantone2726C}
  }
  
  & .MuiInputBase-root {
    position: relative;
    overflow: hidden;
  }

  & .MuiInputBase-root::after {
    left: 0;
    right: 0;
    bottom: 0;
    content: "";
    position: absolute;
    transform: scaleX(0);
    transition: transform 200ms cubic-bezier(0.0, 0, 0.2, 1) 0ms;
    pointer-events: none;
    border-bottom: 2px solid ${({ theme }) => theme.pantone2726C};
  }

  & .MuiInputBase-root.Mui-focused {
    ::after {
      transform: scaleX(1);
    }
  }
  
  input {
    padding: 23px 12px 6px;
    height: 1.1876em !important;
  }

  * {
    border: none;
  }
}
`;

export const AreaButton = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
  flex: 1;
  gap: 1rem;
  margin-top: 1rem;

  button {
    margin: 0;
  }

  @media (max-width: 600px) {
    flex-direction: column-reverse;

    button {
      max-width: 100% !important;
    }
  }
`;

export const AreaIpRestriction = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;

  @media (max-width: 600px) {
    flex-direction: column;

    button {
      max-width: 100% !important;
    }
  }
`;

export const AreaFooter = styled.div<{ $hasGridData: boolean }>`
  display: flex;
  flex-direction: ${({ $hasGridData }) => ($hasGridData ? 'column' : 'row')};

  @media (max-width: 600px) {
    flex-direction: column;
  }
`;